var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-notifications-subscription"},[_c('user-notifications-query',{on:{"data":_vm.onData},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
return [_c('user-new-notification-subscription',{on:{"data":_vm.onSubscriptionData}}),_vm._t("default",null,{"isLoading":isLoading,"notifications":_vm.notifications})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }